import cruise1 from "./full/GRN_0093.webp";
import cruise2 from "./full/20240518_092429.webp";
import cruise3 from "./full/20240908_095405.webp";
import cruise4 from "./full/[Group 7].webp";
import cruise5 from "./full/20240922_093124.webp";
import cruise6 from "./full/Przystan czorsztyn dron_42.webp";
import cruise7 from "./full/cruise.webp";
import cruise8 from "./full/IMG_0263.webp";
import cruise9 from "./full/1.webp";
import cruise10 from "./full/20240709_144529.webp";
import cruise11 from "./full/Przystan czorsztyn dron_50.webp";
import cruise12 from "./full/IMG_0508.webp";
import cruise1Thumb from "./thumb/GRN_0093.webp";
import cruise2Thumb from "./thumb/20240518_092429.webp";
import cruise3Thumb from "./thumb/20240908_095405.webp";
import cruise4Thumb from "./thumb/[Group 7].webp";
import cruise5Thumb from "./thumb/20240922_093124.webp";
import cruise6Thumb from "./thumb/Przystan czorsztyn dron_42.webp";
import cruise7Thumb from "./thumb/cruise.webp";
import cruise8Thumb from "./thumb/IMG_0263.webp";
import cruise9Thumb from "./thumb/1.webp";
import cruise10Thumb from "./thumb/20240709_144529.webp";
import cruise11Thumb from "./thumb/Przystan czorsztyn dron_50.webp";
import cruise12Thumb from "./thumb/IMG_0508.webp";

export const cruiseImages = [
    { thumb: cruise1Thumb, full: cruise1, altKey: "1" },
    { thumb: cruise2Thumb, full: cruise2, altKey: "2" },
    { thumb: cruise3Thumb, full: cruise3, altKey: "3" },
    { thumb: cruise4Thumb, full: cruise4, altKey: "4" },
    { thumb: cruise5Thumb, full: cruise5, altKey: "5" },
    { thumb: cruise6Thumb, full: cruise6, altKey: "6" },
    { thumb: cruise7Thumb, full: cruise7, altKey: "7" },
    { thumb: cruise8Thumb, full: cruise8, altKey: "8" },
    { thumb: cruise9Thumb, full: cruise9, altKey: "9" },
    { thumb: cruise10Thumb, full: cruise10, altKey: "10" },
    { thumb: cruise11Thumb, full: cruise11, altKey: "11" },
    { thumb: cruise12Thumb, full: cruise12, altKey: "12" }
];